<template>
<div class="column">
    <div class="row">
		<div class="col-xl-12">
			<holiday-breaks
				class="col-xs-12 col-md-10 mx-auto ml-xl-0"
				v-model="holiday_breaks"
				:create_url="create_break_url"
				:update_url="update_break_url"
				:destroy_url="destroy_break_url"
				:copy_jobs="true"
			></holiday-breaks>
		</div>
    </div>
	<div class="row">
		<div class="col-xl-12">
			<week-work-days
				class="mx-auto ml-xl-0"
				v-model="work_week"
				:save_url="save_week_url"
			></week-work-days>
		</div>
	</div>
</div>
</template>

<script>
	import HolidayBreaks from "../settings/HolidayBreaks";
	import WeekWorkDays from "../settings/WeekWorkDays";
	export default {
		name: "GlobalSettingsPage",
		components: {WeekWorkDays, HolidayBreaks},
		props: {
			company: {
				type: Object,
				required: true
			},
			save_week_url: {
				type: String,
				required: true
			},
			create_break_url: {
				type: String,
				required: true
			},
			update_break_url: {
				type: String,
				required: true
			},
			destroy_break_url: {
				type: String,
				required: true
			}
		},

		data() {
			return {
				work_week: null,
				holiday_breaks: null,

				saving_week: false,
				saving_holidays: false,
			}
		},

		beforeMount() {
			this.work_week = Object.assign({}, this.company.work_week);
			this.holiday_breaks = Object.assign([], this.company.holiday_breaks);
		}
	}
</script>
